const initState =
{
  modal01       : false,
}

const modalsReducer = (state = initState, action) =>
{
  switch (action.type)
  {    
    case 'SET_MODAL_01':
      return {
        ...state,
        modal01: action.modal01
      };

    default:
      return state; 
  }
}

export default modalsReducer;